import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "register-area pt-120 mb-120" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-12" }
const _hoisted_5 = { class: "form-wrapper" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "form-title" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Employer Sign Up"),
  /*#__PURE__*/_createElementVNode("span")
], -1)
const _hoisted_7 = { class: "register-tab" }
const _hoisted_8 = {
  class: "tab-content",
  id: "nav-tabContent"
}
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "form-inner mb-25" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "first_tname" }, "First Name*", -1)
const _hoisted_13 = { class: "input-area" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/icon/user-2.svg",
  alt: ""
}, null, -1)
const _hoisted_15 = ["rules"]
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "form-inner mb-25" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { for: "last_name" }, "Last Name*", -1)
const _hoisted_19 = { class: "input-area" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/icon/user-2.svg",
  alt: ""
}, null, -1)
const _hoisted_21 = ["rules"]
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = { class: "form-inner mb-25" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email*", -1)
const _hoisted_25 = { class: "input-area" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/icon/email-2.svg",
  alt: ""
}, null, -1)
const _hoisted_27 = ["rules"]
const _hoisted_28 = { class: "col-md-6" }
const _hoisted_29 = { class: "form-inner mb-25" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { for: "company_name" }, "Company Name*", -1)
const _hoisted_31 = { class: "input-area" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/icon/company-2.svg",
  alt: ""
}, null, -1)
const _hoisted_33 = ["rules"]
const _hoisted_34 = { class: "col-md-6" }
const _hoisted_35 = { class: "form-inner mb-25" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", null, "Industry Type*", -1)
const _hoisted_37 = { class: "input-area" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/icon/category-2.svg",
  alt: ""
}, null, -1)
const _hoisted_39 = { class: "col-md-6" }
const _hoisted_40 = { class: "form-inner mb-25" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Location", -1)
const _hoisted_42 = { class: "input-area" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/icon/loction.svg",
  alt: ""
}, null, -1)
const _hoisted_44 = { class: "col-md-12" }
const _hoisted_45 = { class: "form-inner mb-25" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", null, "Address", -1)
const _hoisted_47 = { class: "col-md-6" }
const _hoisted_48 = { class: "form-inner mb-25" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Password*", -1)
const _hoisted_50 = ["rules"]
const _hoisted_51 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-eye-slash",
  id: "togglePassword3"
}, null, -1)
const _hoisted_52 = {
  key: 0,
  style: {"color":"red !important","font-size":"small !important","position":"relative","left":"5px","top":"-1.4rem !important"}
}
const _hoisted_53 = { class: "col-md-6" }
const _hoisted_54 = { class: "form-inner" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", { for: "retype_password" }, "Confirm Password*", -1)
const _hoisted_56 = ["rules"]
const _hoisted_57 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-eye-slash",
  id: "togglePassword4"
}, null, -1)
const _hoisted_58 = {
  key: 0,
  style: {"color":"red !important","font-size":"small !important","position":"relative","left":"5px","top":"3px !important"}
}
const _hoisted_59 = { class: "col-md-12" }
const _hoisted_60 = { class: "form-agreement form-inner d-flex justify-content-between flex-wrap" }
const _hoisted_61 = { class: "form-group two" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", { for: "html" }, "By registering, you acknowledge and agree to our terms and conditions", -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-md-12",
  id: "form-error"
}, null, -1)
const _hoisted_64 = { class: "col-md-12" }
const _hoisted_65 = { class: "form-inner" }
const _hoisted_66 = ["disabled"]
const _hoisted_67 = {
  key: 1,
  class: "primry-btn-2",
  type: "button"
}
const _hoisted_68 = /*#__PURE__*/_createElementVNode("span", { class: "me-3 fs-6 text-white" }, "Processing...", -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-spinner fa-spin text-white",
  style: {"font-size":"24px"}
}, null, -1)
const _hoisted_70 = [
  _hoisted_68,
  _hoisted_69
]
const _hoisted_71 = /*#__PURE__*/_createStaticVNode("<div class=\"login-difarent-way\"><div class=\"row g-4\"><div class=\"col-md-6\"><a href=\"https://myaccount.google.com/\"><img src=\"assets/images/icon/google1.svg\" alt=\"\">Log in with Google</a></div><div class=\"col-md-6\"><a href=\"https://www.facebook.com/\"><img src=\"assets/images/icon/facebook1.svg\" alt=\"\">Log in with Facebook</a></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("form", {
                    onSubmit: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.createEmployer()), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _hoisted_12,
                          _createElementVNode("div", _hoisted_13, [
                            _hoisted_14,
                            _withDirectives(_createElementVNode("input", {
                              name: "first_name",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.employerForm.first_name) = $event)),
                              type: "text",
                              id: "first_name",
                              placeholder: "Mr. Robert",
                              rules: _ctx.firstName
                            }, null, 8, _hoisted_15), [
                              [_vModelText, _ctx.employerForm.first_name]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _hoisted_18,
                          _createElementVNode("div", _hoisted_19, [
                            _hoisted_20,
                            _withDirectives(_createElementVNode("input", {
                              name: "last_name",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.employerForm.last_name) = $event)),
                              type: "text",
                              id: "last_name",
                              placeholder: "Jonson",
                              rules: _ctx.lastName,
                              onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.fillOther && _ctx.fillOther(...args)))
                            }, null, 40, _hoisted_21), [
                              [_vModelText, _ctx.employerForm.last_name]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _hoisted_24,
                          _createElementVNode("div", _hoisted_25, [
                            _hoisted_26,
                            _withDirectives(_createElementVNode("input", {
                              name: "email",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.employerForm.email) = $event)),
                              type: "email",
                              id: "email",
                              placeholder: "robert@gmail.com",
                              rules: _ctx.validateEmail,
                              onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.setUserName && _ctx.setUserName(...args)))
                            }, null, 40, _hoisted_27), [
                              [_vModelText, _ctx.employerForm.email]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _hoisted_30,
                          _createElementVNode("div", _hoisted_31, [
                            _hoisted_32,
                            _withDirectives(_createElementVNode("input", {
                              name: "company_name",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.employerForm.company_name) = $event)),
                              type: "text",
                              id: "company_name",
                              placeholder: "Mr. Robert",
                              rules: _ctx.companyName
                            }, null, 8, _hoisted_33), [
                              [_vModelText, _ctx.employerForm.company_name]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _hoisted_36,
                          _createElementVNode("div", _hoisted_37, [
                            _hoisted_38,
                            _createVNode(_component_Dropdown, {
                              name: "company_type",
                              onChange: _ctx.changeCompanyType,
                              modelValue: this.employerForm.company_type_id,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((this.employerForm.company_type_id) = $event)),
                              options: _ctx.companyTypes,
                              ref: "companyType",
                              optionLabel: "name",
                              optionValue: "id",
                              placeholder: "Industry Type",
                              class: "w-full",
                              rules: _ctx.companyType
                            }, null, 8, ["onChange", "modelValue", "options", "rules"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                          _hoisted_41,
                          _createElementVNode("div", _hoisted_42, [
                            _hoisted_43,
                            _createVNode(_component_Dropdown, {
                              name: "suburb_id",
                              onChange: _ctx.changeLocation,
                              modelValue: this.employerForm.location_id,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((this.employerForm.location_id) = $event)),
                              options: _ctx.states,
                              ref: "suburb_id",
                              optionLabel: "name",
                              optionValue: "id",
                              placeholder: "Select Location",
                              class: "w-full"
                            }, null, 8, ["onChange", "modelValue", "options"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("div", _hoisted_45, [
                          _hoisted_46,
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.employerForm.address) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.employerForm.address]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("div", _hoisted_48, [
                          _hoisted_49,
                          _withDirectives(_createElementVNode("input", {
                            name: "password",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.employerForm.password) = $event)),
                            type: "password",
                            id: "password3",
                            placeholder: "Password",
                            ref: "password_comp",
                            rules: _ctx.passWord,
                            onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.passCheck && _ctx.passCheck(...args)))
                          }, null, 40, _hoisted_50), [
                            [_vModelText, _ctx.employerForm.password]
                          ]),
                          _hoisted_51
                        ]),
                        (!_ctx.validPass)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(_ctx.validationMessage), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("div", _hoisted_54, [
                          _hoisted_55,
                          _withDirectives(_createElementVNode("input", {
                            name: "retype_password",
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.employerForm.password_confirmation) = $event)),
                            type: "password",
                            id: "password4",
                            placeholder: "Confirm Password",
                            rules: _ctx.RetypePassWord,
                            onChange: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.isConfirm && _ctx.isConfirm(...args)))
                          }, null, 40, _hoisted_56), [
                            [_vModelText, _ctx.employerForm.password_confirmation]
                          ]),
                          _hoisted_57
                        ]),
                        (!_ctx.confirmPass)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_58, _toDisplayString(_ctx.confirmText), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("div", _hoisted_60, [
                          _createElementVNode("div", _hoisted_61, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.is_agree) = $event)),
                              id: "html"
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.is_agree]
                            ]),
                            _hoisted_62
                          ])
                        ])
                      ]),
                      _hoisted_63,
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("div", _hoisted_65, [
                          (!_ctx.isLoading)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.createEmployer && _ctx.createEmployer(...args))),
                                class: "primry-btn-2",
                                type: "button",
                                disabled: !_ctx.validPass || !_ctx.confirmPass || !_ctx.is_agree
                              }, "Sign Up", 8, _hoisted_66))
                            : (_openBlock(), _createElementBlock("button", _hoisted_67, _hoisted_70))
                        ])
                      ]),
                      _createElementVNode("h6", null, [
                        _createTextVNode("Already have an account? "),
                        _createVNode(_component_router_link, { to: "/login" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Login")
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Here")
                      ]),
                      _hoisted_71
                    ])
                  ], 32)
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}